<template>
  <el-row>
    <el-row v-if="!patient">
      <el-form ref="form" :inline="true" :model="meta.form" @submit.native.prevent class="left top-pad">
        <el-form-item>
          <el-input
            @keyup.enter.native="queryKeyword()"
            size="small"
            v-model="keyword"
            placeholder="请输入姓名、电话"
            v-loading="loading"
            style="width: 220px;vertical-align: middle"
          >
            <el-button
              slot="append"
              type="info"
              size="small"
              icon="el-icon-search"
              @click="queryKeyword()"
              :loading="loading"
            >
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <dict-selector v-model="meta.form.idType" dict-type="IdType" style="width: 190px; margin-top: 1px" />
        </el-form-item>
        <el-form-item prop="idNo" :rules="$utils.cardRule()">
          <el-input @keyup.enter.native="query()" size="small" v-model="meta.form.idNo" placeholder="请输入证件号码" v-loading="meta.searching" style="vertical-align: middle">
            <el-button slot="append" type="info" size="small" icon="el-icon-search" @click="query()" :loading="meta.searching"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <id-reader @ok="cardRead" @err="cardErr" />
        </el-form-item>
        <el-form-item v-if="setting.ifMedicallnsurance">
          <el-button size="small" type="info" icon="el-icon-bank-card" @click="meta.showMedReader=true">医保读卡</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!hideCreate" size="small" type="info" icon="el-icon-user-solid" @click="create">新患者建档</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-descriptions v-else :title="patient.name" :column="5">
      <template slot="title">
        <span>{{ patient.name }}</span>
        <el-tag v-if="Enum.OpType.医保工伤 == opType" class="left-pad" effect="plain" type="danger">{{ opType }}患者 </el-tag>
        <el-tag v-else-if="Enum.OpType.医保 == opType" class="left-pad" effect="plain" type="warning">{{ opType }}患者 </el-tag>
        <el-tag v-else class="left-pad" effect="plain" type="success">{{ opType }}患者 </el-tag>
        <el-tag class="left-pad" type="danger" effect="dark" v-if="patient.enterprise && patient.enterprise.name">
          <small class="large">{{ patient.enterprise.name }}</small>
        </el-tag>
      </template>
      <template slot="extra">
        <el-button v-if="!hideSwitch" size="small" type="warning" class="left-pad" icon="el-icon-sort" @click="cancel">切换患者</el-button>
        <el-button v-if="!hideEdit" size="small" type="info" icon="el-icon-edit" @click="edit">编辑患者</el-button>
      </template>
      <el-descriptions-item label="卡号">{{ patient.cardNo }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ patient.gender | dictText("Gender") }}</el-descriptions-item>
      <el-descriptions-item label="年龄">{{ patient.patientAge }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.idType" label="证件">{{ patient.idType | dictText("IdType") }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.idNo" label="号码">{{ patient.idNo | mask }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.ethnicity" label="民族">{{ patient.ethnicity | dictText("Ethnicity") }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.nativePlaceProvince" label="籍贯">{{ patient.nativePlaceProvince }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.insuranceNo" label="社保">{{ patient.insuranceNo }}</el-descriptions-item>
      <el-descriptions-item v-if="patient.injuries" label="工伤部位" :span="8">
        <el-checkbox-group v-if="patient && patient.injuries && patient.injuries.length" v-model="selectInjuries" @change="injuriesChange">
          <el-checkbox v-for="item in patient.injuries" :label="item.id" :key="item.id" :title="item.proces" v-model="item.checked">{{ `${item.id}. ${item.partordisease} ${item.time}` }}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
    </el-descriptions>
    <patient-editor title="患者" v-model="editingPatient" :visible.sync="meta.showEditor" @saved="saved"></patient-editor>
    <med-reader :visible.sync="meta.showMedReader" only-baseinfo @ok="medRead"></med-reader>

    <!--模糊搜索多出个患者数据时，弹窗-->
    <el-dialog
      append-to-body
      title="请选择"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="() => dialogVisible = false">
      <el-table
        border
        row-key="id"
        :data="tableData"
        highlight-current-row
        @current-change="selectionChange"
      >
        <el-table-column width="50" align="center" label="操作">
          <template slot-scope="scope">
            <el-radio v-model="selectionKey" :label="scope.$index"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column label="患者" prop="name" align="center"></el-table-column>
        <el-table-column label="性别" prop="gender" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender | dictText("Gender") }}
          </template>
        </el-table-column>
        <el-table-column label="年龄" prop="patientAge" align="center"></el-table-column>
        <el-table-column label="手机号" prop="phone" align="center"></el-table-column>
        <el-table-column label="证件号码" prop="idNo" align="center" width="200"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
  import api from "@/common/api";
  import { mapGetters } from "vuex";
  export default {
    components: {
      // "in-reader": () => import("@/components/_com/insuranceCardReader"),
      "patient-editor": () => import("@/components/patient/editor"),
    },
    props: {
      value: Object,
      type: String,
      center: Boolean,
      hideCreate: Boolean,
      hideEdit: Boolean,
      hideSwitch: Boolean,
    },
    data() {
      return {
        meta: {
          showEditor: false,
          showPay: false,
          searching: false,
          showMedReader: false,
          form: {
            idType: null,
            idNo: '',
          },
        },
        patient: null,
        editingPatient: null,
        opType: "自费",
        selectInjuries: [],
        keyword: '',
        loading: false,
        dialogVisible: false,
        tableData: [],
        selectionKey: null
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user", "setting"]),
    },
    watch: {
      value() {
        this.patient = this.value;
      },
      patient() {
        this.selectInjuries = [];
        this.injuriesChange(this.selectInjuries);
      },
    },
    methods: {
      injuriesChange(val) {
        this.$emit("injuries", val);
      },
      queryKeyword() {
        this.loading = true;
        if (!this.keyword) {
          return;
        }
        api.getPatientByKeyword({ keyword: this.keyword.trim() })
          .then(({items}) => {
            if (!Array.isArray(items)) {
              return;
            }
            if (items.length > 1) {
              this.dialogVisible = true;
              this.tableData = items;
            } else if (items[0]) {
              this.emitFn(items[0]);
            } else {
              this.$message.error('患者记录不存在！');
            }
            this.keyword = '';
          })
          .finally(() => this.loading = false);
      },
      // 如果来自列表的快捷读取身份证，validateFlag为false，即不需要校验
      async query(val, validateFlag = true) {
        // try {
        //   await this.$refs.form.validate();
        // } catch (error) {
        //   return;
        // }
        if (val) {
          this.meta.form.idNo = val.idNo;
          this.meta.form.idType = val.idType;
        }
        if (validateFlag) await this.$refs.form.validate();

        this.meta.searching = true;
        let idNo = this.meta.form.idNo;
        if (this.meta.form.idType === 'LS') {
          // 院内卡号时，补0
          idNo = this.$utils.padLeft(this.meta.form.idNo, 12, '0');
        }
        try {
          let res = await api.getPatientByIdNo(idNo, this.meta.form.idType); //证件类型
          if (!res || !res.id) {
            throw new Error("患者记录不存在！");
          }
          this.patient = res;
          this.patient.cardType = res.idType;
          this.patient.cardNo = res.code;
          this.meta.form.idNo = null;
          try {
            const enterprise = await api.getEnterpriseByPat(this.patient.id);
            this.$set(this.patient, 'enterprise', enterprise)
          } catch (err) {
            this.$utils.log('enterprise-catch', err)
          }
          this.ok();
        } catch (err) {
          if (err) {
            this.$message.error(err.message || err);
          }
        } finally {
          this.meta.searching = false;
        }
      },
      edit() {
        this.editingPatient = this.$utils.clone(this.patient);
        this.meta.showEditor = true;
      },
      create() {
        this.$set(this, "editingPatient", { idType: "SF" });
        this.meta.showEditor = true;
      },
      saved(val) {
        this.editingPatient = null;
        this.patient = val;
        this.patient.cardType = val.idType;
        this.patient.cardNo = val.code;
        this.ok();
      },
      ok() {
        this.$emit("input", this.patient);
        this.$emit("ok", this.patient, this.opType);
      },
      cancel() {
        this.patient = null;
        this.$emit("input", this.patient);
        this.$emit("cancel");
      },
      cardRead(val) {
        if (!val.idNo) {
          this.$message.error("暂无读卡患者信息");
        } else {
          this.$set(this.meta.form, "idNo", val.idNo);
          this.$set(this.meta.form, "idType", val.idType);
          this.query();
        }
      },
      cardErr(val) {
        this.$message.error(val);
        this.meta.searching = false;
      },
      opTypeChange({ name }) {
        this.$emit("update:type", name);
      },
      medRead(val) {
        if (val.baseinfo?.certno) {
          this.$set(this.meta.form, "idNo", val.baseinfo.certno);
          // this.$set(this.meta.form, "idType", val.baseinfo.psn_cert_type);
          this.query();
        }
      },
      selectionChange(row) {
        this.tableData.forEach((item, index) => {
          if (JSON.stringify(item) === JSON.stringify(row)) {
            this.selectionKey = index;
          }
        });
        this.emitFn(row);
        setTimeout(() => {
          this.keyword = '';
          this.selectionKey = null;
          this.dialogVisible = false;
        }, 1000);
      },
      emitFn(val) {
        val.cardNo = val.code;
        this.$emit('input', val);
        this.$emit('ok');
      }
    },
  };
</script>
<style scoped>
.large {
  font-size:16px;
  letter-spacing: 2px;
}
</style>
